import React from 'react';
import { componentService } from 'js/services/component.service';

export const GoldenChipsBalances = React.lazy(() => import(/* webpackChunkName: "golden-chips-balances" */ './GoldenChipsBalances'));

componentService.registerPageComponents({ goldenchips: GoldenChipsBalances });
